import { useMemo } from 'react';

import { useQueryState } from 'hooks/useQueryState';

import { useQueryGetIntegratedScheduleDetails } from 'api/queries/getIntegratedScheduleDetails.query';

import MainTable from 'components/common/Tables/MainTable/MainTable';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import {
    columns,
    defaultColumn,
    initialState,
} from 'components/widgets/CrossProgramRelationships/CrossProgramRelationships.utils';
import classes from 'components/widgets/InputPrograms/InputPrograms.module.scss';

export const CrossProgramRelationships = () => {
    const [metaDataId] = useQueryState('metaDataId');
    const { data, isLoading, isFetching } = useQueryGetIntegratedScheduleDetails({
        fileMetaDataId: Number(metaDataId),
    });

    const integratedScheduleDetails = useMemo(() => {
        return data ? data.integratedScheduleDetails : [];
    }, [data]);

    return (
        <WidgetWithTitle title={`Cross Program Relationships (${integratedScheduleDetails.length})`}>
            <div className={classes.container}>
                <MainTable
                    columns={columns}
                    initialState={initialState}
                    data={integratedScheduleDetails}
                    defaultColumn={defaultColumn}
                    isLoading={isLoading || isFetching}
                />
            </div>
        </WidgetWithTitle>
    );
};
